import { EventAvailable, Lock, LockOpen, MeetingRoom, Public } from "@mui/icons-material";
import FilterCardBar from "components/FilterCardBar";
import { API_URL } from "config";
import { useAppContextController } from "context/AppContext";
import useBadgeValues from "hooks/useBadgeValues";
import { useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
// import ToggleOffIcon from '@mui/icons-material/ToggleOff';

// import FiltersList from "components/FiltersList";

const PayrollStatusFilterCards = ({ filters, setFilters, setPage, currentPeriod }) => {
  const { setCurrentEvent } = useAppContextController();
  const [refreshBadges, setRefreshBadges] = useState(false);
  const { currentLoggedUser } = useAppContextController();

  const filterCardVenues = currentLoggedUser?.venues?.length
    ? currentLoggedUser.venues.join(";")
    : "";

  const initialCards = [
    {
      color: "success",
      icon: <LockOpen fontSize="large" color="success" />,
      title: "Open",
      tooltip: "Events/Jobs without a submitted Payroll",
      number: 0,
      filters: {
        payrollStatus: "Pending",
      },
    },
    {
      color: "error",
      icon: <Lock fontSize="large" color="error" />,
      title: "Closed",
      tooltip: "Events/Jobs without a submitted Payroll",
      number: 0,
      filters: {
        payrollStatus: "Submitted",
      },
    },
    {
      color: "dark",
      icon: <Public fontSize="large" color="black" />,
      title: "All",
      tooltip: "All Events/Jobs",
      default: true,
      number: 0,
      filters: {},
    },
  ];

  const initialIndex = initialCards.findIndex((card) => card.default);
  const topFilters = useMemo(() => {
    const result = { ...filters };
    delete result.payrollStatus;
    return result;
  }, [filters]);

  const { cards } = useBadgeValues({
    initialCards,
    filters: topFilters,
    entity: "payroll/combined",
    refreshBadges,
    extraParams: `&startDate=${currentPeriod?.[0]?.toISOString()}&endDate=${currentPeriod?.[1]?.toISOString()}`,
  });
  const navigate = useNavigate();

  const setEventFilters = (filter) => {
    navigate("/payroll");
    setCurrentEvent(null);

    if (filter.payrollStatus) {
      setFilters({ ...filters, payrollStatus: filter.payrollStatus });
    } else {
      const newFilters = { ...filters };
      delete newFilters.payrollStatus;
      setFilters(newFilters);
    }

    setRefreshBadges((prev) => !prev);
  };

  return (
    <span>
      <FilterCardBar
        cards={cards}
        parent="Events"
        bgColor="primary"
        setFilters={setEventFilters}
        setPage={setPage}
        initialIndex={initialIndex}
      />
    </span>
  );
};

export default PayrollStatusFilterCards;
